export function parseCCH(cchText, SMTs) {
  console.log("Parsing CCH text...");
  cchText = cchText.replace(/\u00A0/g, " "); //replace non breaking spaces with regular spaces
  cchText = cchText.replace(
    /[\u2010\u2011\u2012\u2013\u2014\u2015\u2212]/g,
    "-"
  );
  // strip zero-width chars that sometimes sneak in from PDFs
  cchText = cchText.replace(/[\u200B-\u200D\uFEFF]/g, "");

  let names = [];
  if (cchText.includes("NAME: ")) {
    let rawNames = cchText.split("NAME: ")[1].split("DATE(S)")[0].trim();
    if (rawNames !== null && rawNames !== undefined) {
      names = rawNames
        .replace("ALIAS: ", "")
        .split("\n")
        .map((name) => name.trim())
        .filter((name) => name.length > 0);
    }
  }

  //get dobs from oh cch

  let dobs = [];
  if (cchText.includes("DATE(S) OF BIRTH:")) {
    let rawDOBs = cchText.split("DATE(S) OF BIRTH:")[1].split("SEX")[0].trim();
    const rawDateArray = rawDOBs.trim().split(/\s+/);
    const formattedDOBs = reformatOHCCHDates(rawDateArray);
    dobs.push(...formattedDOBs);
  }

  //get dobs from iii qr
  if (cchText.includes("BIRTH DATES")) {
    if (cchText.includes("IDENTIFICATION DATA")) {
      let searchArea = cchText
        .split("BIRTH DATES")[1]
        .split("IDENTIFICATION DATA")[0]
        .trim();
      let rawDOBs = searchArea.match(/(\d{4}\/\d{2}\/\d{2})/g);

      dobs.push(...reformatIIIQRDates(rawDOBs));
    }
  }

  //get soicals, needs more testing
  let rawSOCs = cchText.match(/(\d{9})/g);
  let socs = [];
  if (rawSOCs !== null) {
    socs.push(...Array.from(rawSOCs));
  }
  let rawSOCs2 = cchText.match(/(\d{3}-\d{2}-\d{4})/g);
  console.log("hey");
  console.log(rawSOCs2);
  if (rawSOCs2 !== null) {
    let formatted = Array.from(rawSOCs2).map((soc) => {
      return soc.replace(/-/g, "");
    });

    socs = socs.concat(...formatted);
  }

  //SMTs
  let smts = [];
  SMTs.forEach((code) => {
    if (cchText.includes(code.Code)) {
      smts.push(code.Code);
    }
  });

  //get sids
  let rawSIDs = cchText.match(/STATE ID\/(\S+)/g);
  let sids = [];

  if (rawSIDs !== null) {
    sids = Array.from(rawSIDs).map((sid) => sid.replace("STATE ID/", ""));
  }

  dobs = Array.from(
    new Set(
      dobs
        .filter(
          (item) =>
            item !== undefined &&
            item !== null &&
            typeof item === "string" &&
            item.trim() !== "" &&
            !item.includes("undefined")
        )
        .map((item) => item.trim())
    )
  );
  socs = Array.from(
    new Set(
      socs
        .filter(
          (item) =>
            item !== undefined &&
            item !== null &&
            typeof item === "string" &&
            item.trim() !== "" &&
            !item.includes("undefined")
        )
        .map((item) => item.trim())
    )
  );
  smts = Array.from(
    new Set(
      smts
        .filter(
          (item) =>
            item !== undefined &&
            item !== null &&
            typeof item === "string" &&
            item.trim() !== "" &&
            !item.includes("undefined")
        )
        .map((item) => item.trim())
    )
  );
  sids = Array.from(
    new Set(
      sids
        .filter(
          (item) =>
            item !== undefined &&
            item !== null &&
            typeof item === "string" &&
            item.trim() !== "" &&
            !item.includes("undefined")
        )
        .map((item) => item.trim())
    )
  );
  names = Array.from(
    new Set(
      names
        .filter(
          (item) =>
            item !== undefined &&
            item !== null &&
            typeof item === "string" &&
            item.trim() !== "" &&
            !item.includes("undefined")
        )
        .map((item) => item.trim())
    )
  );
  console.log("Finished parsing CCH text.");

  return {
    dobs: dobs,
    socs: socs,
    smts: smts,
    sids: sids,
    akas: names,
  };
}

function reformatOHCCHDates(dateArray) {
  const monthMap = {
    JAN: "01",
    FEB: "02",
    MAR: "03",
    APR: "04",
    MAY: "05",
    JUN: "06",
    JUL: "07",
    AUG: "08",
    SEP: "09",
    OCT: "10",
    NOV: "11",
    DEC: "12",
  };

  return dateArray.map((d) => {
    const year = d.slice(0, 4);
    const month = monthMap[d.slice(4, 7).toUpperCase()];
    const day = d.slice(7, 9);
    return `${year}${month}${day}`; // e.g. "1989-02-13"
  });
}

function reformatIIIQRDates(dateArray) {
  return dateArray.map((d) => {
    const year = d.slice(0, 4);
    const month = d.slice(5, 7);
    const day = d.slice(8, 10);
    return `${year}${month}${day}`; // e.g. "1989-02-13"
  });
}
